export function sortColumnValues(values, hasBlank, options) {
  const sorted = Array.from(values).sort((a, b) => {
    if (
      options?.isEnumColumn &&
      options.column &&
      options.getEnumDisplayValue
    ) {
      const displayA = String(
        options.getEnumDisplayValue(options.column, a) ?? a
      );
      const displayB = String(
        options.getEnumDisplayValue(options.column, b) ?? b
      );
      return displayA.localeCompare(displayB);
    }
    return String(a).localeCompare(String(b));
  });
  if (hasBlank) {
    sorted.unshift("<blank>");
  }
  return sorted;
}

export function groupOptionsByLabel(
  uniqueValues,
  valueCounts,
  getValueDisplayLabel,
  selectedValues,
  getValueStartIcon
) {
  const byLabel = new Map();
  uniqueValues.forEach((value) => {
    const label = getValueDisplayLabel(value);
    const selectionId = value === "<blank>" ? "" : value;
    const count = valueCounts.find((e) => e.internalName === value)?.count || 0;
    const existing = byLabel.get(label);
    if (existing) {
      existing.ids.push(selectionId);
      existing.count += count;
      existing.startIcon = existing.startIcon ?? getValueStartIcon?.(value);
    } else {
      byLabel.set(label, {
        id: label,
        label,
        ids: [selectionId],
        count,
        startIcon: getValueStartIcon?.(value),
      });
    }
  });
  return Array.from(byLabel.values()).map((group) => ({
    ...group,
    selected: group.ids.every((id) => selectedValues.has(id)),
  }));
}

export function filterValuesBySearch(values, searchQuery, options) {
  if (!searchQuery.trim()) return values;
  const query = searchQuery.toLowerCase();
  return values.filter((value) => {
    if (
      options?.isEnumColumn &&
      options.column &&
      options.getEnumDisplayValue
    ) {
      const displayValue =
        options.getEnumDisplayValue(options.column, value) ?? value;
      return (
        value.toLowerCase().includes(query) ||
        displayValue.toLowerCase().includes(query)
      );
    }
    return value.toLowerCase().includes(query);
  });
}
